import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/metas-loja')({
  component: lazyRouteComponent(
    () => import('@/features/metas/components/metas-loja-page'),
    'MetasLojaPage'
  ),
})
